export default {
  store({ invoice }) {
    return axios
      .post(
        `${ import.meta.env.VITE_SITE_URL }/bookkeepings/invoices`,
        { invoice },
      );

  },

  update({ invoice }) {
    return axios
      .put(
        `${ import.meta.env.VITE_SITE_URL }/bookkeepings/invoices/${ invoice.id }`,
        { invoice },
      );

  },

  getInvoiceTypes() {
    return axios.get(`${ import.meta.env.VITE_SITE_URL }/bookkeepings/invoice_type?list`);
  },

  convertNumberToText({ number }) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/helper/convert_number_to_text', { number });
  },

  show({ id }) {
    return axios.get(`${ import.meta.env.VITE_SITE_URL }/bookkeepings/invoices/${ id }`);
  },

  obtainInvoiceEmail({ id }) {
    return axios.get(`${ import.meta.env.VITE_SITE_URL }/bookkeepings/invoices/${ id }/email`);
  },

  generateInvoiceNumber({ numberTemplateId, issueDate }) {
    return axios.get(`${ import.meta.env.VITE_SITE_URL }/bookkeepings/invoice_number/${ numberTemplateId }/${ issueDate }`);
  },

  getInvoiceNumberTemplate({ invoiceTypeId }) {
    return axios.get(`${ import.meta.env.VITE_SITE_URL }/bookkeepings/invoice_number_template/${ invoiceTypeId }?list`);
  },

  calculateInvoice({ invoice }) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/bookkeepings/invoices/calculate',
      { invoice },
    );
  },

  calculateInvoiceCorrectionDifference({ invoiceBeforeCorrectionValues, invoiceAfterCorrectionValues, invoice }) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/bookkeepings/invoices/calculateCorrectionDifference',
      {
        invoiceBeforeCorrectionValues,
        invoiceAfterCorrectionValues,
        invoice,
      });
  },

  printData({ invoiceId }, params = {}) {
    return axios
      .get(
        `${ import.meta.env.VITE_SITE_URL }/bookkeepings/invoices/printData/${ invoiceId }`,
        {
          params,
        },
      );
  },

  previewData({ invoiceId }, params = {}) {
    return axios
      .get(
        `${ import.meta.env.VITE_SITE_URL }/bookkeepings/invoices/previewData/${ invoiceId }`,
        {
          params,
        },
      );
  },

  send({ invoiceId, data }) {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/bookkeepings/invoices/send/${ invoiceId }`, data);
  },

  exportToSymfonia(params = {}) {
    return axios
      .post(
        `${ import.meta.env.VITE_SITE_URL }/bookkeepings/invoices/exportToSymfonia`,
        params,
      );

  },

  exportSymfonia(params = {}) {
    return axios
      .post(
        `${ import.meta.env.VITE_SITE_URL }/bookkeepings/invoices/export/symfonia`,
        params, {
          responseType: 'arraybuffer',
        },
      );

  },

  indexLinkedInvoices({ crmOriginal }, params = {}) {
    return axios
      .get(
        `${ import.meta.env.VITE_SITE_URL }/bookkeepings/invoices/linked/${ crmOriginal }`,
        params,
      );
  },

  calculateAdvance({ family_id }, params = {}) {
    return axios.get(import.meta.env.VITE_SITE_URL + `/bookkeepings/invoices/calculate/advance/${ family_id }`,
      params,
    );
  },
};
